import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, ViewEncapsulation } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { CoreHttpClient, MarketConfigService } from "@obg/ngx.core";
import { RouteService } from "@obg/ngx.router";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { SbResponse, Sport } from "./sitemap.model";

@Component({
	selector: "obg-m-sitemap",
	templateUrl: "./sitemap.html",
	styleUrls: ["./sitemap.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Sitemap implements OnDestroy {
	@HostBinding("class.obg-m-sitemap") hostCssClass = true;
	sbRoute$ = this.routeService.generateUrl$({ routeName: "sportsbook" });
	sports$: Observable<Sport[]> = this.httpClient
		.get({
			url: `seo/v1/sports-book/site-map-content/${this.marketConfig.getLanguageCode()}`,
		})
		.pipe(map((sbResponse: SbResponse) => sbResponse.sports));

	private sbRouteSubscription: Subscription;

	constructor(
		private httpClient: CoreHttpClient,
		private routeService: RouteService,
		private marketConfig: MarketConfigService,
		private titleService: Title
	) {
		this.sbRouteSubscription = this.sbRoute$.subscribe((sbRoute) => {
			if (sbRoute) {
				this.titleService.setTitle("Sportsbook Site Map");
			}
		});
	}

	ngOnDestroy() {
		if (this.sbRouteSubscription) {
			this.sbRouteSubscription.unsubscribe();
		}
	}
}
